import axios from "axios";
import { Base_URL } from "../url";

export const saveCurrencyDetails = async (currencyData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CurrencyMaster/CurrencyMaster?UserName=${username}`,
      currencyData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving currency details!";
  }
};

export const getAllCurrencies = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CurrencyMaster/GetAllCurrencies`
    );
    return response.data; // Assuming API returns an array of currencies
  } catch (error) {
    throw error.response?.data || "Error fetching currencies!";
  }
};
